export default __webpack_public_path__ + "static/roof_w.1dd3643b52be08de0297ad13f40ea979.png";